module.exports = __webpack_public_path__ + "img/Leyes.8350275d.png";